const C = require("../constants");

const selectProduct = (data) => {
    return {
        type: C.PRODUCT_SELECT,
        data
    }
};

export {selectProduct};


// WEBPACK FOOTER //
// ./src/actions/ProductSelectActions.js